.cell {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-xs);
}

.label {
  font-size: var(--mantine-font-size-sm);
  font-weight: 600;
  color: var(--adl-text-secondary);
}

.value {
  font-size: var(--mantine-font-size-sm);
  color: var(--adl-text-primary);
}
